import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import { getOptions } from '../../../controllers/OptionsController';

import type {
  FormCheckboxRiskProfileOptionType,
  FormCheckboxRiskProfileControl,
} from 'src/types/form-config';
import { signal, useSignal, useSignalEffect } from '@preact/signals';

const CustomCheckbox = (props: FormCheckboxRiskProfileControl) => {
  const controls = useRef(props);
  const options: any = useSignal([]);
  const allowedLength = useRef(3);
  const selectedOption = useSignal([]);
  const groupOne = useRef(['132', '131']);

  const states = useRef({});

  useSignalEffect(() => {
    const config = controls.current as FormCheckboxRiskProfileControl;

    const selectedOptions: number[] = controls.current.value;

    const customOptions = config.options.map(option => {
      const [questionId, answerId, answerScore] = option.value.split('_');
      if (groupOne.current.includes(answerId)) {
        option.isGroupOne = true;
      }
      option.isChecked = selectedOptions.includes(Number(answerId));
      states.current[option.value] = signal(false);
      return option;
    });

    options.value = customOptions;

    setTimeout(() => {
      customOptions.forEach(item => {
        if (item.isChecked) {
          changeHandler({
            target: { dataset: { value: item.value }, checked: true },
          });
        }
      });
    }, 1000);
  });

  const changeHandler = e => {
    const target = e.target;
    const value = target.dataset.value;

    states.current[value].value = target.checked;

    const isChecked = target.checked;

    if (isChecked) {
      const options = [...selectedOption.value];
      options.push(value);
      selectedOption.value = options;
    } else {
      selectedOption.value = selectedOption.value.filter(item => item != value);
    }
  };

  return (
    <div class="mb-4">
      <label class="mb-2">{props.label}</label>
      {props.options.map((option: FormCheckboxRiskProfileOptionType, index) => {
        return (
          <div class="form-check " key={option.key}>
            <input
              class="form-check-input input"
              type="checkbox"
              data-value={option.value}
              name={option.value}
              id={option.value}
              checked={states.current[option.value]}
              onChange={changeHandler}
            />
            <label class="form-check-label" for={option.value}>
              {option.display}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default CustomCheckbox;
